import { Link } from 'react-router-dom';
import { getAllCategories } from '@/lib/community';
import { formatCount } from '@/lib/format';

const categories = getAllCategories();

export default function CategoryGrid() {
  return (
    <section>
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">话题分类</h2>
          <p className="mt-1 text-sm text-foreground-500">找到你感兴趣的圈子，一起聊</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group relative flex flex-col justify-end overflow-hidden rounded-lg border border-background-200 bg-background-100 h-44 cursor-pointer"
          >
            <img
              src={cat.image}
              alt={cat.name}
              title={`${cat.name}话题讨论区 - 蜜糖社区`}
              className="absolute inset-0 w-full h-full object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent" />
            <div className="relative z-10 p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${cat.icon} text-lg`} />
                </span>
                <span className="text-white font-extrabold text-lg">{cat.name}</span>
              </div>
              <p className="text-xs text-white/80 leading-relaxed line-clamp-2">{cat.description}</p>
              <p className="mt-2 text-[11px] text-primary-200 font-label font-bold">
                {formatCount(cat.topicCount)} 个话题 · 进入讨论
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}